<template>
  <div class="blog__saved">
    <div class="container">

      <div class="row">
        <div class="col-12">
          <h2 class="title">Счастливые истории</h2>
        </div>
      </div>

      <template v-if="loading">
        <loader />
      </template>
      <template v-else>
        <template v-if="!stories.length">
            <h3 class="d-flex justify-content-center align-items-center">
              Статей нет
            </h3>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-12">
              <swiper :options="$options.sliderOptions">

                <template v-for="story in stories">
                  <swiper-slide :key="story.slug">
                    <saved-article :article="story" />
                  </swiper-slide>
                </template>

              </swiper>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <slider-pagination 
                :idPrev="'saved-prev'" :idNext="'saved-next'"
                :navigationBtn="$options.navigationBtn"
              />
            </div>
          </div>
        </template>
      </template>
      
    </div>
  </div>
</template>

<script>

import { getPosts } from './api'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import SavedArticle from './SavedArticle.vue'
import SliderPagination from './SliderPagination.vue'
import Loader from '../LoaderBalls.vue'


export default {
    name: "BlogSaved",
    components: { Swiper, SwiperSlide, SavedArticle, SliderPagination, Loader },

    data(){
      return{
        loading: false,
        stories: []
      }
    },

    mounted(){
      this.fetchStories()
    },

    navigationBtn: {
      href: '#',
      text: 'Смотреть все'
    },

    sliderOptions: {
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: '#saved-next',
        prevEl: '#saved-prev',
     },
      breakpoints: {
          320: {
              slidesPerView: 1, // or 'auto'
          },
          768:{
              slidesPerView: 2,
          },
          992: {
              slidesPerView: 3,
          },
      },
    },

    methods: {

        async fetchStories () {
            this.loading = true
            try{ 
                const params = { per_page: 15, only_happy: 1 }
                let { data, success } = await getPosts({ params })
                
                if( success ) {
                    this.stories = data
                    this.loading = false
                }

            } catch ( e ){
              this.loading = false
            }

        }

    },

}
</script>

<style>

</style>